import React from 'react';
import {
  Button,
  ButtonToolbar
} from 'react-bootstrap';
import PropTypes from 'prop-types';

import formContextAware from './formContextAware.jsx';
import SubmitButton from './SubmitButton.jsx';

const FormSubmitButtonGroup = ({ children, isSubmitting, onCancel, onSubmit, primarySubmit, submitText, ...props }) => (
  <ButtonToolbar>
    <SubmitButton bsStyle="primary" onClick={onSubmit} className={isSubmitting ? 'btn-loading' : null} { ...props }>
      {submitText}
    </SubmitButton>
    {children}
    <Button className="btn-tertiary" disabled={isSubmitting} onClick={onCancel}>Cancel</Button>
  </ButtonToolbar>
);

FormSubmitButtonGroup.propTypes = {
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  primarySubmit: PropTypes.bool,
  submitText: PropTypes.string,
};

FormSubmitButtonGroup.defaultProps = {
  isSubmitting: false,
  onCancel: () => { },
  onSubmit: () => { },
  primarySubmit: true,
  submitText: 'Save',
};

let FormContextAwareSubmitButtonGroup = formContextAware(FormSubmitButtonGroup);

export default FormContextAwareSubmitButtonGroup;
